import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Terminal18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.93934 10L4.46967 8.53033L5.53033 7.46967L8.06066 10L5.53033 12.5303L4.46967 11.4697L5.93934 10Z'
      fill='currentColor'
    />
    <path d='M9 12.75H13V11.25H9V12.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H15.5C16.1904 1.25 16.75 1.80964 16.75 2.5V15.5C16.75 16.1904 16.1904 16.75 15.5 16.75H2.5C1.80964 16.75 1.25 16.1904 1.25 15.5V2.5ZM2.75 2.75V4.25H4.25V2.75H2.75ZM5.75 2.75V4.25H15.25V2.75H5.75ZM2.75 15.25V5.75H15.25V15.25H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Terminal18.displayName = 'Terminal18';
export default Terminal18;
